export enum NumType {
  Fixed = 0,
  RandomAmount = 1,
  RandomPercent = 2,
  ReservedAmount = 3,
  All = 4
}

export enum Status {
  Loading = 1,
  NoStart = 0,
  Success = 2,
  Fail = 3,
  Success1 = 4
}